module.exports = __webpack_public_path__ + "img/green-pita-04.3982bc0b.png";